import { Heart, Plus } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useCommerce } from '../contexts/CommerceContext';
import { imageSource, imageSrcSet } from '../lib/assets';
import { formatPrice } from '../lib/format';
import type { Product } from '../types';

export function ProductCard({ product }: { product: Product }) {
  const { addToCart, isFavorite, toggleFavorite } = useCommerce();
  const image = product.images[0];
  const secondImage = product.images[1];
  const soldOut = product.stockByVariant && Object.values(product.stockByVariant).every((stock) => stock < 1);

  return (
    <article className="product-card">
      <div className="product-image-wrap">
        <Link to={`/produto/${product.slug}`} className="product-image-link" aria-label={`Ver ${product.name}`}>
          <img className="product-image primary" src={imageSource(image)} srcSet={imageSrcSet(image)} sizes="(max-width: 700px) 50vw, (max-width: 1100px) 33vw, 25vw" loading="lazy" alt={image.alt} />
          {secondImage && <img className="product-image secondary" src={imageSource(secondImage)} srcSet={imageSrcSet(secondImage)} sizes="(max-width: 700px) 50vw, (max-width: 1100px) 33vw, 25vw" loading="lazy" alt="" aria-hidden="true" />}
        </Link>
        <button className={`favorite-button ${isFavorite(product.id) ? 'is-favorite' : ''}`} onClick={() => toggleFavorite(product.id)} aria-label={isFavorite(product.id) ? `Remover ${product.name} dos favoritos` : `Favoritar ${product.name}`}>
          <Heart size={18} fill={isFavorite(product.id) ? 'currentColor' : 'none'} />
        </button>
        {(product.newProduct || product.bestSeller) && <span className="product-label">{product.newProduct ? 'Novidade' : 'Mais vendido'}</span>}
      </div>
      <div className="product-copy">
        <p className="product-category">{product.collection}</p>
        <div className="product-title-row"><h3><Link to={`/produto/${product.slug}`}>{product.name}</Link></h3><span>{formatPrice(product.promotionalPrice ?? product.price)}</span></div>
        <div className="product-meta">
          <span className="color-list" aria-label={`Cores: ${product.colors.map((color) => color.name).join(', ')}`}>{product.colors.map((color) => <i key={color.name} style={{ backgroundColor: color.hex }} title={color.name} />)}</span>
          {soldOut ? <span className="sold-out">Esgotado</span> : <button className="add-inline" onClick={() => addToCart(product, product.colors[0].name, product.sizes[0])}><Plus size={15} /> Adicionar</button>}
        </div>
      </div>
    </article>
  );
}
